"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Catalog = _interopRequireDefault(require("./Catalog"));
var _ProductDisplayDetail = _interopRequireDefault(require("./ProductDisplayDetail"));
var _ProductOption = _interopRequireDefault(require("./ProductOption"));
var _Tag = _interopRequireDefault(require("./Tag"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The ModifyUserDetails model module.
 * @module model/ModifyUserDetails
 * @version 3.0
 */
var ModifyUserDetails = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>ModifyUserDetails</code>.
   * @alias module:model/ModifyUserDetails
   */
  function ModifyUserDetails() {
    _classCallCheck(this, ModifyUserDetails);
    ModifyUserDetails.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(ModifyUserDetails, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>ModifyUserDetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ModifyUserDetails} obj Optional instance to populate.
     * @return {module:model/ModifyUserDetails} The populated <code>ModifyUserDetails</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new ModifyUserDetails();
        if (data.hasOwnProperty('productId')) {
          obj['productId'] = _ApiClient["default"].convertToType(data['productId'], 'Number');
        }
        if (data.hasOwnProperty('productLegacyId')) {
          obj['productLegacyId'] = _ApiClient["default"].convertToType(data['productLegacyId'], 'String');
        }
        if (data.hasOwnProperty('productLegacyGroupId')) {
          obj['productLegacyGroupId'] = _ApiClient["default"].convertToType(data['productLegacyGroupId'], 'String');
        }
        if (data.hasOwnProperty('catalog')) {
          obj['catalog'] = _Catalog["default"].constructFromObject(data['catalog']);
        }
        if (data.hasOwnProperty('subCatalog')) {
          obj['subCatalog'] = _Catalog["default"].constructFromObject(data['subCatalog']);
        }
        if (data.hasOwnProperty('productName')) {
          obj['productName'] = _ApiClient["default"].convertToType(data['productName'], 'String');
        }
        if (data.hasOwnProperty('upfrontCost')) {
          obj['upfrontCost'] = _ApiClient["default"].convertToType(data['upfrontCost'], 'Number');
        }
        if (data.hasOwnProperty('upfrontVat')) {
          obj['upfrontVat'] = _ApiClient["default"].convertToType(data['upfrontVat'], 'Number');
        }
        if (data.hasOwnProperty('recurringCost')) {
          obj['recurringCost'] = _ApiClient["default"].convertToType(data['recurringCost'], 'Number');
        }
        if (data.hasOwnProperty('recurringVat')) {
          obj['recurringVat'] = _ApiClient["default"].convertToType(data['recurringVat'], 'Number');
        }
        if (data.hasOwnProperty('recurringFrequency')) {
          obj['recurringFrequency'] = _ApiClient["default"].convertToType(data['recurringFrequency'], 'Number');
        }
        if (data.hasOwnProperty('recurringFrequencyUnit')) {
          obj['recurringFrequencyUnit'] = _ApiClient["default"].convertToType(data['recurringFrequencyUnit'], 'String');
        }
        if (data.hasOwnProperty('costUnit')) {
          obj['costUnit'] = _ApiClient["default"].convertToType(data['costUnit'], 'String');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('recurring')) {
          obj['recurring'] = _ApiClient["default"].convertToType(data['recurring'], 'Boolean');
        }
        if (data.hasOwnProperty('validity')) {
          obj['validity'] = _ApiClient["default"].convertToType(data['validity'], 'Number');
        }
        if (data.hasOwnProperty('validityUnit')) {
          obj['validityUnit'] = _ApiClient["default"].convertToType(data['validityUnit'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('rank')) {
          obj['rank'] = _ApiClient["default"].convertToType(data['rank'], 'Number');
        }
        if (data.hasOwnProperty('billingMode')) {
          obj['billingMode'] = _ApiClient["default"].convertToType(data['billingMode'], 'String');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('subCategory')) {
          obj['subCategory'] = _ApiClient["default"].convertToType(data['subCategory'], 'String');
        }
        if (data.hasOwnProperty('localizedCategory')) {
          obj['localizedCategory'] = _ApiClient["default"].convertToType(data['localizedCategory'], 'String');
        }
        if (data.hasOwnProperty('href')) {
          obj['href'] = _ApiClient["default"].convertToType(data['href'], 'String');
        }
        if (data.hasOwnProperty('additionalInformation')) {
          obj['additionalInformation'] = _ApiClient["default"].convertToType(data['additionalInformation'], 'String');
        }
        if (data.hasOwnProperty('saleStartDate')) {
          obj['saleStartDate'] = _ApiClient["default"].convertToType(data['saleStartDate'], 'Date');
        }
        if (data.hasOwnProperty('saleExpiryDate')) {
          obj['saleExpiryDate'] = _ApiClient["default"].convertToType(data['saleExpiryDate'], 'Date');
        }
        if (data.hasOwnProperty('navigable')) {
          obj['navigable'] = _ApiClient["default"].convertToType(data['navigable'], 'Boolean');
        }
        if (data.hasOwnProperty('tags')) {
          obj['tags'] = _ApiClient["default"].convertToType(data['tags'], [_Tag["default"]]);
        }
        if (data.hasOwnProperty('options')) {
          obj['options'] = _ApiClient["default"].convertToType(data['options'], [_ProductOption["default"]]);
        }
        if (data.hasOwnProperty('displayDetails')) {
          obj['displayDetails'] = _ApiClient["default"].convertToType(data['displayDetails'], [_ProductDisplayDetail["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ModifyUserDetails</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ModifyUserDetails</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['productLegacyId'] && !(typeof data['productLegacyId'] === 'string' || data['productLegacyId'] instanceof String)) {
        throw new Error("Expected the field `productLegacyId` to be a primitive type in the JSON string but got " + data['productLegacyId']);
      }
      // ensure the json data is a string
      if (data['productLegacyGroupId'] && !(typeof data['productLegacyGroupId'] === 'string' || data['productLegacyGroupId'] instanceof String)) {
        throw new Error("Expected the field `productLegacyGroupId` to be a primitive type in the JSON string but got " + data['productLegacyGroupId']);
      }
      // validate the optional field `catalog`
      if (data['catalog']) {
        // data not null
        _Catalog["default"].validateJSON(data['catalog']);
      }
      // validate the optional field `subCatalog`
      if (data['subCatalog']) {
        // data not null
        _Catalog["default"].validateJSON(data['subCatalog']);
      }
      // ensure the json data is a string
      if (data['productName'] && !(typeof data['productName'] === 'string' || data['productName'] instanceof String)) {
        throw new Error("Expected the field `productName` to be a primitive type in the JSON string but got " + data['productName']);
      }
      // ensure the json data is a string
      if (data['recurringFrequencyUnit'] && !(typeof data['recurringFrequencyUnit'] === 'string' || data['recurringFrequencyUnit'] instanceof String)) {
        throw new Error("Expected the field `recurringFrequencyUnit` to be a primitive type in the JSON string but got " + data['recurringFrequencyUnit']);
      }
      // ensure the json data is a string
      if (data['costUnit'] && !(typeof data['costUnit'] === 'string' || data['costUnit'] instanceof String)) {
        throw new Error("Expected the field `costUnit` to be a primitive type in the JSON string but got " + data['costUnit']);
      }
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['validityUnit'] && !(typeof data['validityUnit'] === 'string' || data['validityUnit'] instanceof String)) {
        throw new Error("Expected the field `validityUnit` to be a primitive type in the JSON string but got " + data['validityUnit']);
      }
      // ensure the json data is a string
      if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
        throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
      }
      // ensure the json data is a string
      if (data['billingMode'] && !(typeof data['billingMode'] === 'string' || data['billingMode'] instanceof String)) {
        throw new Error("Expected the field `billingMode` to be a primitive type in the JSON string but got " + data['billingMode']);
      }
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // ensure the json data is a string
      if (data['subCategory'] && !(typeof data['subCategory'] === 'string' || data['subCategory'] instanceof String)) {
        throw new Error("Expected the field `subCategory` to be a primitive type in the JSON string but got " + data['subCategory']);
      }
      // ensure the json data is a string
      if (data['localizedCategory'] && !(typeof data['localizedCategory'] === 'string' || data['localizedCategory'] instanceof String)) {
        throw new Error("Expected the field `localizedCategory` to be a primitive type in the JSON string but got " + data['localizedCategory']);
      }
      // ensure the json data is a string
      if (data['href'] && !(typeof data['href'] === 'string' || data['href'] instanceof String)) {
        throw new Error("Expected the field `href` to be a primitive type in the JSON string but got " + data['href']);
      }
      // ensure the json data is a string
      if (data['additionalInformation'] && !(typeof data['additionalInformation'] === 'string' || data['additionalInformation'] instanceof String)) {
        throw new Error("Expected the field `additionalInformation` to be a primitive type in the JSON string but got " + data['additionalInformation']);
      }
      if (data['tags']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['tags'])) {
          throw new Error("Expected the field `tags` to be an array in the JSON data but got " + data['tags']);
        }
        // validate the optional field `tags` (array)
        var _iterator = _createForOfIteratorHelper(data['tags']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _Tag["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      if (data['options']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['options'])) {
          throw new Error("Expected the field `options` to be an array in the JSON data but got " + data['options']);
        }
        // validate the optional field `options` (array)
        var _iterator2 = _createForOfIteratorHelper(data['options']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _ProductOption["default"].validateJSON(_item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      if (data['displayDetails']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['displayDetails'])) {
          throw new Error("Expected the field `displayDetails` to be an array in the JSON data but got " + data['displayDetails']);
        }
        // validate the optional field `displayDetails` (array)
        var _iterator3 = _createForOfIteratorHelper(data['displayDetails']),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item2 = _step3.value;
            _ProductDisplayDetail["default"].validateJSON(_item2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} productId
 */
ModifyUserDetails.prototype['productId'] = undefined;

/**
 * @member {String} productLegacyId
 */
ModifyUserDetails.prototype['productLegacyId'] = undefined;

/**
 * @member {String} productLegacyGroupId
 */
ModifyUserDetails.prototype['productLegacyGroupId'] = undefined;

/**
 * @member {module:model/Catalog} catalog
 */
ModifyUserDetails.prototype['catalog'] = undefined;

/**
 * @member {module:model/Catalog} subCatalog
 */
ModifyUserDetails.prototype['subCatalog'] = undefined;

/**
 * @member {String} productName
 */
ModifyUserDetails.prototype['productName'] = undefined;

/**
 * @member {Number} upfrontCost
 */
ModifyUserDetails.prototype['upfrontCost'] = undefined;

/**
 * @member {Number} upfrontVat
 */
ModifyUserDetails.prototype['upfrontVat'] = undefined;

/**
 * @member {Number} recurringCost
 */
ModifyUserDetails.prototype['recurringCost'] = undefined;

/**
 * @member {Number} recurringVat
 */
ModifyUserDetails.prototype['recurringVat'] = undefined;

/**
 * @member {Number} recurringFrequency
 */
ModifyUserDetails.prototype['recurringFrequency'] = undefined;

/**
 * @member {String} recurringFrequencyUnit
 */
ModifyUserDetails.prototype['recurringFrequencyUnit'] = undefined;

/**
 * @member {String} costUnit
 */
ModifyUserDetails.prototype['costUnit'] = undefined;

/**
 * @member {String} currency
 */
ModifyUserDetails.prototype['currency'] = undefined;

/**
 * @member {Boolean} recurring
 */
ModifyUserDetails.prototype['recurring'] = undefined;

/**
 * @member {Number} validity
 */
ModifyUserDetails.prototype['validity'] = undefined;

/**
 * @member {String} validityUnit
 */
ModifyUserDetails.prototype['validityUnit'] = undefined;

/**
 * @member {String} description
 */
ModifyUserDetails.prototype['description'] = undefined;

/**
 * @member {Number} rank
 */
ModifyUserDetails.prototype['rank'] = undefined;

/**
 * @member {String} billingMode
 */
ModifyUserDetails.prototype['billingMode'] = undefined;

/**
 * @member {String} category
 */
ModifyUserDetails.prototype['category'] = undefined;

/**
 * @member {String} subCategory
 */
ModifyUserDetails.prototype['subCategory'] = undefined;

/**
 * @member {String} localizedCategory
 */
ModifyUserDetails.prototype['localizedCategory'] = undefined;

/**
 * @member {String} href
 */
ModifyUserDetails.prototype['href'] = undefined;

/**
 * @member {String} additionalInformation
 */
ModifyUserDetails.prototype['additionalInformation'] = undefined;

/**
 * @member {Date} saleStartDate
 */
ModifyUserDetails.prototype['saleStartDate'] = undefined;

/**
 * @member {Date} saleExpiryDate
 */
ModifyUserDetails.prototype['saleExpiryDate'] = undefined;

/**
 * @member {Boolean} navigable
 */
ModifyUserDetails.prototype['navigable'] = undefined;

/**
 * @member {Array.<module:model/Tag>} tags
 */
ModifyUserDetails.prototype['tags'] = undefined;

/**
 * @member {Array.<module:model/ProductOption>} options
 */
ModifyUserDetails.prototype['options'] = undefined;

/**
 * @member {Array.<module:model/ProductDisplayDetail>} displayDetails
 */
ModifyUserDetails.prototype['displayDetails'] = undefined;
var _default = exports["default"] = ModifyUserDetails;